import { render, staticRenderFns } from "./TaxCard.vue?vue&type=template&id=032ce892&"
import script from "./TaxCard.vue?vue&type=script&lang=js&"
export * from "./TaxCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports